<div class="page-padding">
  <fgbcl-auction-wallet-details [id]="id"></fgbcl-auction-wallet-details>
</div>
